<template lang="pug">
	.network-show-list.flex-col.space
		ListView.full-width(
			ref="list",
			initialView="table",
			:getTotal="(r) => r.TotalNumberOfRecords",
			:getItems="(r) => r.Results",
			:getData="$Data.getNetworkShows",
			:columns="columns",
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="30",
			:showColumnHeaders="false"
		)
			.flex-row.space.align-center(slot="left-actions")
				.font-big.upper.grey.tb-padding {{$tCaption('Network shows')}}
				DxButton(icon="plus", @click="newShow", :hint="$tCaption('Create new show')")
			template(v-slot:displayValue="{ data }")
				.show-item.flex-row.flex1.space-medium(@click="openShow(data)")
					.show-logo(v-if="data.LogoUrl || data.PictureUrl", :style="{ '--img': `url('${data.LogoUrl || data.PictureUrl}')` }")
					.flex-col.space.wrap.flex-1
						.flex-row.align-center.space-medium
							.flex-row.align-center.space
								.font-big {{data.Name || $tCaption('Show')}}
								.grey(v-if="data.Subname") ({{data.Subname}})
							.show-status.flex-row.align-center.space-small(:class="{ published: data.Status }")
								fas(v-if="data.Status === 1", icon="check")
								span {{data.Status ? $tCaption('Published') : $tCaption('Not published')}}
						.flex-row.space-medium.align-center.grey
							.flex-row.space(v-if="data.ScheduleStartDateGmt")
								.grey {{$tCaption('Starts:')}}
								span {{$moment(data.ScheduleStartDateGmt).format('LLL')}}
							.flex-row.space(v-if="data.ScheduleEndDateGmt")
								.grey {{$tCaption('Ends:')}}
								span {{$moment(data.ScheduleEndDateGmt).format('LLL')}}
						span(v-if="data.Description") {{data.Description}}
</template>

<script>
	import ListView from 'app-core/ListView.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'networkShow.List',
		name: 'network-show-list',
		components: {
			ListView,
			DxButton,
		},
		data() {
			return {
				columns: [
					{ dataField: 'Name', cellTemplate: 'displayValue', caption: this.$tCaption('Name') }
				],
				
			};
		},
		methods: {
			newShow() {
				this.$router.push({ path: '/network-studio/show/new' });
			},
			openShow(show) {
				this.$router.push({ path: `/network-studio/show/${show.Oid}` });
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show-list {
		.show-item {
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				color: $base-accent;
			}

			.show-logo {
				width: 48px;
				height: 48px;
				background: var(--img);
				background-position: center;
				background-size: cover;
				border-radius: 4px;
			}
		}

		.show-status {
			font-size: 10px;
			padding: 2px 4px;
			border-radius: 4px;
			background: rgba(0,0,0,0.05);
			color: #333;

			&.published {
				background: $base-accent;
				color: $base-bg;
			}
		}
	}
</style>
